var exports = {
  "k": "x93eb46d8--c7f41a--container",
};

module.exports = exports;
